import { get, post, remove, patch } from 'api.vanilla.service';
import { formatErrorMessage } from 'api/helpers';
import { set as setFeedback } from 'feedback.vanilla.service.js';

import phrases from './rawIngredientCategories.phrases';

/**
 * @function fetchRawIngredientCategories
 * @description Fetch all raw ingredient categories
 * @param {object} state
 */
export function fetchRawIngredientCategories(state) {
	// Set params and filter
	const params = {
		limit: state.limit,
		sort: state.sort,
		offset: state.offset,
		filter: state.filter
	};

	return get(
		'/inventory/raw_ingredient_categories',
		params,
		null,
		state.headers
	)
		.then(res => {
			return res;
		})
		.catch(err => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
		});
}

/**
 * @function addRawIngredientCategories
 * @description adds raw ingredient categories
 */
export function addRawIngredientCategories(data) {
	return post('/inventory/raw_ingredient_categories', data)
		.then(res => {
			setFeedback(phrases.RAW_INGREDIENT_CATEGORIES_ADDED, 1);
			return res;
		})
		.catch(err => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}

/**
 * @function editRawIngredientCategory
 * @description edits raw ingredient categories
 */
export function editRawIngredientCategory(data) {
	return post(`/inventory/raw_ingredient_categories/${data.id}`, data)
		.then(res => {
			setFeedback(phrases.RAW_INGREDIENT_CATEGORY_EDITED, 1);
			return res;
		})
		.catch(err => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			return Promise.reject;
		});
}

/**
 * @function editRawIngredientCategories
 * @description edits raw ingredient categories
 */
export function editRawIngredientCategories(data) {
	return patch('/inventory/raw_ingredient_categories', data)
		.then(res => {
			setFeedback(phrases.RAW_INGREDIENT_CATEGORIES_EDITED, 1);
			return res;
		})
		.catch(err => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			return Promise.reject;
		});
}

/**
 * @function deleteRawIngredientCategories
 * @description deletes raw ingredient categories
 */
export function deleteRawIngredientCategories(id) {
	return remove(`/inventory/raw_ingredient_categories/${id}`)
		.then(res => {
			setFeedback(phrases.RAW_INGREDIENT_CATEGORIES_DELETED, 1);
			return res;
		})
		.catch(err => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}
